import { includes, isNil, some } from 'lodash'

import { BookingDTOInitiatorParty, BookingDTOState } from '@/clients/booking'
import { BookingDTO } from '@/clients/booking'

export enum BookingAction {
  Authorize = 'authorize',
  Reject = 'reject',
}

export const canAuthorizeBooking = (booking: BookingDTO) => {
  const authorizeActions: BookingAction[] = [BookingAction.Authorize, BookingAction.Reject]
  const permitedActionsIncludeAuthorize = some(booking.links, (link) => includes(authorizeActions, link.rel))

  return (
    booking.state === BookingDTOState.Open &&
    isNil(booking.controllingPartyApprovedAt) &&
    booking.initiatorParty === BookingDTOInitiatorParty.Shipper &&
    permitedActionsIncludeAuthorize
  )
}
